@if (currentPage()?.data?.length) {
  <div class="document-card-container">
    @for (document of currentPage()!.data; track document) {
      <div class="card" [attr.aria-label]="document.documentTitle">
        <div class="card--icon" [style.background-image]="'url(' + document.iconUrl + ')'">
          @if (document.isGenericIcon) {
            <p>{{document.fileExtension}}</p>
          }
        </div>
        <div class="card--text">
          <div class="card--text__primary"><p>{{document.clientName}}</p></div>
          <div class="card--text__secondary">
            <div class="document-title">{{document.documentTitle}}</div>
            <div class="document-uploaded-datetime">{{document.uploadedDateTimeString}}</div>
          </div>
        </div>
        <div class="card--download-button">
          <button (click)="buttonClicked.emit(document)" [attr.aria-label]="document.downloadButtonLabel">{{document.downloadButtonText}}</button>
        </div>
        <button class="card--download-icon" (click)="buttonClicked.emit(document)" [attr.aria-label]="document.downloadButtonLabel">
          <svg-icon src="assets/icons/common/download.svg"
          svgClass="arrow"></svg-icon>
        </button>
      </div>
    }
  </div>
}
